import { forwardRef, useCallback, useLayoutEffect, useRef } from "react"

function assignRef(ref, value) {
  if (ref == null) return
  if (typeof ref === "function") ref(value)
  else ref.current = value
}

const CheckBox = forwardRef(function CheckBox(
  {
    checked,
    action,
    onChange,
    onClick,
    disabled = false,
    text,
    className = "rounded-md border-gray-400 hover:cursor-pointer",
    indeterminate,
  },
  ref
) {
  const innerRef = useRef(null)

  const setRefs = useCallback(
    (node) => {
      innerRef.current = node
      assignRef(ref, node)
    },
    [ref]
  )

  useLayoutEffect(() => {
    const el = innerRef.current
    if (el == null || indeterminate === undefined) return
    el.indeterminate = Boolean(indeterminate)
  }, [indeterminate, checked])

  const handleChange = (e) => {
    if (onChange) onChange(e)
    else if (action) action(e.target.checked)
  }

  return (
    <div
      className={
        text
          ? "flex flex-row items-center justify-center gap-4"
          : "inline-flex items-center justify-center"
      }
    >
      {text && <span className="text-xs whitespace-nowrap">{text}</span>}
      <input
        ref={setRefs}
        type="checkbox"
        className={className}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        onClick={onClick}
      />
    </div>
  )
})

CheckBox.displayName = "CheckBox"

export default CheckBox
